
interface PageHeroProps {
  badge: string;
  title: string;
  titleHighlight: string;
  description: string;
}

export default function PageHero({ badge, title, titleHighlight, description }: PageHeroProps) {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/454c35a96397f7d6d944b96e629a5f76.jpg"
          alt="Page Background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/85 via-navy/80 to-navy/90"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full">
        <div className="inline-block mb-4 px-4 py-2 bg-gold/10 border border-gold/20 rounded-md">
          <span className="text-gold text-base font-semibold">{badge}</span>
        </div>
        <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight text-white">
          {title}
          <br />
          <span className="text-gold">{titleHighlight}</span>
        </h1>
        <p className="text-lg md:text-xl text-white/70 max-w-3xl mx-auto leading-relaxed">
          {description}
        </p>
      </div>
    </section>
  );
}
